module.exports = __webpack_public_path__ + "img/welcome-icon-04.eee048ff.png";